import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import GaussianBellCurve from './GaussianBellCurve';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
};

export default function LeaderDetailModal({ open, handleClose, leaderName, distribution }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="leader-detail-modal-title"
      aria-describedby="leader-detail-modal-description"
    >
      <Box sx={style}>
        <Typography id="leader-detail-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
          Distribución de Puntajes Calibrados para {leaderName}
        </Typography>
        {distribution && Object.keys(distribution).length > 0 ? (
          <GaussianBellCurve distribution={distribution} />
        ) : (
          <Typography variant="body2" color="text.secondary">No hay datos de distribución de puntaje para este líder.</Typography>
        )}
        <Button onClick={handleClose} variant="contained" sx={{ mt: 3 }}>Cerrar</Button>
      </Box>
    </Modal>
  );
} 